module.exports = {
  title: '通用件车型匹配',
  route: {
    path: '/platform-goods-manage',
    children: {
      path: 'universalpart-cars-matching',
    },
  },
};
